import React from "react";
import SendIcon from "@material-ui/icons/Send";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";

export function AnswerSentAlert({ sent }) {
  return (
    <div className={sent ? "answer-sent-alert" : "answer-sent-alert done"}>
      <div>
        <SendIcon />
      </div>
      <div>
        <EventLabel2 name="AnswerSent" groupName="DigitalMeeting.Client" />
      </div>
    </div>
  );
}
